export default __webpack_public_path__ + "static/tucson-d2fec5abfd4fb0f32b09704e0b00b4ed.png";